// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2RkKP","approved":"Status_approved__2Tv3I","rejected":"Status_rejected__1JHup","expired":"Status_expired__3k6o4","label":"Status_label__1dQUe"};